import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { AppSettingsService } from '../services/app-settings.service';
import { ApplicationService } from '../services/application.service';
import { platformSettings } from 'src/app/models/platformSettings';
import { applicationSetting } from 'src/app/models/applicationSetting';

@Component({
  selector: 'app-userbar',
  templateUrl: './userbar.component.html',
  styleUrls: ['./userbar.component.css']
})
export class UserbarComponent implements OnInit {
  protected assureLoginUrl = AppSettingsService.appSettings.AssureLoginUrl;
  protected helpDeskUrl = AppSettingsService.appSettings.HelpUrl;
  
  showWelcome: boolean;
  nameSet: boolean;
  username: string;


  constructor(private router: Router, 
              private applicationService: ApplicationService) { }

  ngOnInit() { 
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        this.showWelcome = sessionStorage.getItem('token') == null ? false : true;    
      }
    });   
  }

  ngDoCheck(){
    if(this.nameSet)
      return;

    if(this.showWelcome && !this.nameSet){
      let userInstance;
      this.applicationService.user.subscribe(user => {userInstance = user});

      if(userInstance == null)
        return;

      if(userInstance != null){
        this.ChangeName();
        return;
      }
    }
  }

  logout() {
    this.applicationService.logout();
  }

  redirect(){
    window.location.href = this.assureLoginUrl
  }

  HelpRedirect() {
    console.log(this.helpDeskUrl)
    window.location.href = this.helpDeskUrl
  }

  ChangeName(){
    this.applicationService.user.subscribe(user => { this.username = user.userName})
    this.nameSet = true;
  }


}
